import { useContext } from "react";
import { ModalsContext } from "../Contexts/ModalsContext";
import "./Modals.css";
import Notification from "../../utils/Notification/Notification";
import LoadingNotification from "../../utils/LoadingNotification/LoadingNotification";

function Modals() {
  const { state } = useContext(ModalsContext);
  const { modalData } = state;

  return (
    <div className="Modals">
      {state.showNotificationModal && (
        <Notification
          timeout={modalData?.timeout}
          text={modalData?.text}
          height={modalData?.height}
          width={modalData?.width}
          type={modalData?.type}
          onClose={modalData?.onClose}
        />
      )}
      {state.showLoadingNotificationModal && <LoadingNotification text={modalData.text} />}
    </div>
  );
}

export default Modals;
